import React from 'react';

export function Library() {
    return (
        <div class='library'>
            <h3>My library</h3>
            <table>
                <thead>
                    <tr>
                        <td>#</td>
                        <td>Title</td>
                        <td>Artiste</td>
                        <td>Time</td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td id='pic'>
                            <li></li>
                            <div class='lib-cell-pic'></div>
                        </td>
                        <td id = 'title'>Title</td>
                        <td id = 'artiste'>Artiste</td>
                        <td>Time</td>
                    </tr>
                    <tr>
                        <td id='pic'>
                            <li></li>
                            <div class='lib-cell-pic'></div>
                        </td>
                        <td id = 'title'>Title</td>
                        <td id = 'artiste'>Artiste</td>
                        <td>Time</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}